const finishChangingExpandNode = (
  prevState,
  { treeId, nodeId, expanded, plugins, adapter },
) => {
  const treeState = prevState[treeId];
  if (!treeState) {
    return prevState;
  }

  const { expansion } = plugins;
  if (!expansion) {
    return prevState;
  }

  return {
    ...prevState,
    [treeId]: expansion.endChangingExpansion(
      treeState,
      nodeId,
      expanded,
      plugins,
    ),
  };
};

export default finishChangingExpandNode;
